import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import axios from 'axios';

function Home() {
    const { state } = useContext(GlobalContext);
    const { jobData, setJobData } = state;

    useEffect(() => {
        axios
            .get('https://dev-example.sanbercloud.com/api/job-vacancy')
            .then((response) => {
                setJobData(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [setJobData]);

    let myDate = new Date();
    let hour = myDate.getHours();

    const greeting = () => {
        if (hour < 12) return 'Good Morning';
        if (hour >= 12 && hour <= 15) return 'Good Afternoon';
        if (hour >= 15 && hour <= 18) return 'Good Evening';
        if (hour >= 18) return 'Good Night';
    };

    let totalJobs = jobData !== null ? jobData.length : 0;
    let jobsClosed = 0;

    if (jobData !== null) {
        jobData.forEach((element) => {
            if (element.job_status === 0) jobsClosed++;
        });
    }

    return (
        <div className='mx-10 flex w-11/12 flex-col items-center rounded-xl bg-white px-10 pt-10 pb-44 shadow-lg md:px-6'>
            <h1 className='text-4xl font-semibold text-gray-800 dark:text-white'>
                {greeting()}, Welcome to the Dashboard
            </h1>
            <h2 className='text-md mt-2 text-gray-400'>
                Hope you have a great day! Here are our statistics for today
            </h2>

            <div className='mt-5 flex h-32 w-10/12 justify-center gap-x-20 p-5'>
                <div className='flex flex-col items-center justify-center'>
                    <h1 className='text-4xl font-extrabold'>{totalJobs}</h1>
                    <p className='font-semibold'>Job Offers</p>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <h1 className='text-4xl font-extrabold text-green-400'>
                        {totalJobs - jobsClosed}
                    </h1>
                    <p className='font-semibold'>Open</p>
                </div>
                <div className='flex flex-col items-center justify-center'>
                    <h1 className='text-4xl font-extrabold text-rose-600'>
                        {jobsClosed}
                    </h1>
                    <p className='font-semibold'>Closed</p>
                </div>
            </div>
        </div>
    );
}

export default Home;
